import { h } from "../_common/jsx-dom.svg.js";

import "./add-to-cart.scss";

const TAG = "add-to-cart";

const VALUE_ATTRIBUTE_NOT_PRESENT = null;

class AddToCart extends HTMLElement {
    static get observedAttributes() {
        return ["disabled"];
    }

    _eleButton;
    _eleContentHolder;
    _isLoading;
    _isDisabled = false;

    get disabled() {
        return this._isDisabled;
    }

    set disabled(flag) {
        if (typeof flag !== "boolean") {
            throw `'disabled' property only accepts boolean value, instead ${typeof flag} is passed in.`;
        }

        if (flag) {
            this.setAttribute("disabled", "");
        } else {
            this.removeAttribute("disabled");
        }
    }

    constructor() {
        super();
        this._isLoading = false;
        this._initInternalDoms();
    }

    _initInternalDoms = () => {
        this._eleButton = (
            <button
                class="add-to-cart-component__action-btn add-to-cart-component__action-btn--add
            add-to-cart-component__action-btn--add-js"
                onClick={this._onAddToCartClicked}
            >
                <span class="add-to-cart-component__action-btn-icon">
                    <i class="fas fa-circle-notch" />
                </span>
                <span
                    class="add-to-cart-component__action-btn-text"
                    ref={r => (this._eleContentHolder = r)}
                />
            </button>
        );
    };

    connectedCallback() {
        this._moveContent();
        this.appendChild(this._eleButton);
        this.classList.add("add-to-cart-component");
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == "disabled" && oldValue !== newValue) {
            const shouldDisable = newValue !== VALUE_ATTRIBUTE_NOT_PRESENT;
            this._setDisableState(shouldDisable);
        }
    }

    _setDisableState = newState => {
        //set internal state property
        this._isDisabled = newState;

        //update internal button state
        this._eleButton.disabled = this._isDisabled;
    };

    _moveContent = () => {
        while (this.childNodes.length > 0) {
            this._eleContentHolder.appendChild(this.childNodes[0]);
        }
    };
    _addForTrade = ({
        productNumber,
        productName,
        quantity,
        cmpGstInclusivePrice,
        gstInclusivePrice,
        unit,
        unitOfMeasure1,
        unitOfMeasure2
    }) => {
        return new Promise((resolve, reject) => {
            try {
                setTimeout(() => {
                    window.Widget.addToList({
                        productNumber,
                        productName,
                        quantity,
                        cmpGstInclusivePrice,
                        gstInclusivePrice,
                        unit,
                        unitOfMeasure1,
                        unitOfMeasure2
                    });
                    resolve();
                }, 500);
            } catch (e) {
                reject();
            }
        });
    };
    _addForRetail = ({ productNumber, quantity, quoteId, lineId, unit }) => {
        return new Promise((resolve, reject) => {
            window.CART.fn.addItems(
                {
                    addItems: [
                        {
                            productCode: productNumber,
                            quantity: quantity,
                            quoteId: quoteId,
                            pack: unit,
                            lineId: lineId
                        }
                    ]
                },
                quoteId,
                resolve,
                reject
            );
        });
    };
    _onAddToCartClicked = async () => {
        this._eleButton.classList.add(
            "add-to-cart-component__action-btn--loading"
        );

        this.disabled = true;

        const userType = this.getAttribute("user-type");
        let promiseOp = null;

        if (userType == "max") {
            promiseOp = this._addForTrade(this.dataset);
        } else {
            promiseOp = this._addForRetail(this.dataset);
        }

        promiseOp
            .then(this._onSuccessCallback)
            .catch(this._onFailCallback)
            .then(this._removeAllStatusClasses)
            .catch(this._removeAllStatusClasses);
    };
    _removeAllStatusClasses = () => {
        setTimeout(() => {
            this.disabled = false;

            this._eleButton.classList.remove(
                "add-to-cart-component__action-btn--success"
            );
            this._eleButton.classList.remove(
                "add-to-cart-component__action-btn--error"
            );
            this._eleButton.classList.remove(
                "add-to-cart-component__action-btn--loading"
            );
        }, 1500);
    };
    _onSuccessCallback = () => {
        this._eleButton.classList.add(
            "add-to-cart-component__action-btn--success"
        );
        this.dispatchEvent(
            new CustomEvent("add-to-cart__add-success", {
                detail: {
                    success: true
                }
            })
        );
    };
    _onFailCallback = e => {
        this._eleButton.classList.add(
            "add-to-cart-component__action-btn--error"
        );
        this.dispatchEvent(
            new CustomEvent("add-to-cart__add-fail", {
                detail: {
                    success: true,
                    error: e.message
                }
            })
        );
    };
}

customElements.define(TAG, AddToCart);



// WEBPACK FOOTER //
// ./src/add-to-cart/add-to-cart.js